import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import './moralRiskHealth.scss'
import moralrisk1 from '../../../images/articles/moralrisk1.jpg'
import moralrisk2 from '../../../images/articles/moralrisk2.jpg'
import moralrisk3 from '../../../images/articles/moralrisk3.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'



const MoralRiskHealth = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <Layout>
      <Seo
        title='Medical AI Risk: A Practical Checklist for Clinics'
        description={translations.Blogmoralrisk1}
        type='article'
        image={moralrisk1}
        jsonLd={[
          articleJsonLd({ headline: translations.Blogmoralrisk, description: translations.Blogmoralrisk1, datePublished: '2024-02-19', dateModified: '2026-09-18', author: translations.Blogmoralrisk14 }),
          articleBreadcrumbs(translations.Blogmoralrisk, '/articles/moralRiskHealth'),
        ]}
      />
      <div className='mlrole-health-container'>
        <div className='mlrole-health  healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.Blogmoralrisk}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.Blogmoralrisk13}</p>
              <p>•</p>
              <p>{translations.Blogmoralrisk14}</p>
            </div>
            <p className='article-author-head'>{translations.Blogmoralrisk15}</p>

          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={moralrisk2} alt='moralrisk2' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='moralRiskHealth' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.Blogmoralrisk1}</p>
              <p>{translations.Blogmoralrisk2}</p>
              <p>{translations.Blogmoralrisk3}</p>
              <p>{translations.Blogmoralrisk4}</p>
              <p>{translations.Blogmoralrisk5}</p>
              <img src={moralrisk3} alt='moralrisk2' className='mlroleHealthImage2' />

              <h2 className='article-secondaty-title'>{translations.Blogmoralrisk6}</h2>

              <p>{translations.Blogmoralrisk7}</p>
              <p>{translations.Blogmoralrisk8}</p>
              <img src={moralrisk1} alt='mlroleHealthImage2' className='mlroleHealthImage2' />
              <p>{translations.Blogmoralrisk9}</p>
              <p>{translations.Blogmoralrisk10}</p>
              <p>{translations.Blogmoralrisk11}</p>
              <p>{translations.Blogmoralrisk12}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/aiDepressive' title={translations.Blogaidepressivemain} />
        </div>
      </div>
    </Layout>
  )
}

export default MoralRiskHealth